<div *ngIf="pageInfo.total"  class="overflow-x-scroll">
  <p >
    {{ 'PAGINATION.found' | translate }} {{ pageInfo.total }} {{ 'PAGINATION.elements' | translate }}
  </p>
  <ngb-pagination (pageChange)="page = $event" [collectionSize]="pageInfo.total" [pageSize]="pageInfo.limit" [(page)]="pageInfo.page" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
</div>
